import { atom } from 'jotai';
export const $CSPScripts = atom({
    'tea-precollect': '',
    'slardar-precollect': '',
    'remix-route-modules': '',
    'remix-server-handoff': '',
});
$CSPScripts.debugLabel = '$CSPScripts';
